import Tooltip from '@antimatterhq/ui/components/tooltip';
import { cn } from '@/lib/utils';
import {
  bronzeMedallionTooltip,
  goldMedallionTooltip,
  silverMedallionTooltip,
} from '@/strings/StringsTooltips';

export const Medallion = ({
  medallion,
}: {
  medallion: 'bronze' | 'silver' | 'gold';
}) => {
  return (
    <Tooltip
      content={
        medallion === 'bronze'
          ? bronzeMedallionTooltip
          : medallion === 'silver'
            ? silverMedallionTooltip
            : goldMedallionTooltip
      }
      side="top"
    >
      <div
        className={cn(
          'h-5 w-5 rounded-full',
          medallion === 'bronze' && 'bg-bronze',
          medallion === 'silver' && 'bg-silver',
          medallion === 'gold' && 'bg-gold',
        )}
      />
    </Tooltip>
  );
};
